@import '../../../../assets/common';

#easm-assets-inventory-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: calc(var(--spacer) * 10);
  width: 100%;
  cursor: default;
  position: relative;

  .overview-section {
    display: flex;
    flex: 1;
    flex-flow: column;
    align-items: center;
    gap: var(--spacer);
    border-right: 1px solid var(--chart-101-pressed-dividers);
  }

  .clickable:hover,
  .clickable:hover * {
    cursor: pointer;
    color: var(--blue-layout-400-primary);
  }

  .overview-section:last-child {
    border-right: none;
  }
}

gz-loader {
  margin-top: calc(var(--spacer) * 8);
}

.value, .section-title {
  color: var(--main-titles-inputs-600);
}
